/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Card , Button, Badge, Modal, Row, Col, ProgressBar} from 'react-bootstrap'
import {ClassesService, UserService, AccountService, ProductService} from '../services';
import {ClassesStore, ProductStore} from '../store';
import Constants from '../constants.js';
import GeneratePDF from '../classes/pdf_generate.js'
import Comfirmation from '../components/popup/comfirmation_popup.js';
import Translation from '../store/internationalization-store.js';
import GeneralTable from '../components/general_table.js';
import Popup from '../components/popup/comfirmation_popup.js'
import FieldGroup from '../components/FieldGroup.js';


export default class StudentManagement extends React.Component {
 
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
            loading:true,
            lastSelected:undefined
        };
    }

    returnEmojiKey(emojiData){
        return <span class="notSelect" onClick={function() {
            if ( this.state.lastSelected == undefined) {
                return;
            }
            var $txt = this.state.lastSelected;
            var caretPos = $txt.selectionStart;
            if (this.state.lastSelectType == "title") {
                var textAreaTxt = this.state.messageTitle;
                var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                this.setState({messageTitle:newTextValue});
            } else {
                var textAreaTxt = this.state.messageMessage;
                var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                this.setState({messageMessage:newTextValue});
            }
        }.bind(this)} style={{fontSize:"30px"}}>{emojiData}</span>
    }

    updateData() {

    }

    componentWillMount(){
        ClassesStore.on(Constants.GET_STUDENTS , () =>{
            this.setState({
                students:ClassesStore.students || [],
                loading:false,
            })

        })
        ProductStore.on(Constants.GET_USER_DATA,  ()=>{
            this.setState({updated:true})
        })
    }

    componentDidMount(){
        ClassesService.getStudentsAll();
        ProductService.getUserData();
    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    handelDownload(){
        this.PDFgen = new GeneratePDF();
        this.PDFgen.generateNoClassPDF(this.state.students);
    }

    handelDownloadSingle(){
        this.PDFgen = new GeneratePDF();
        var studentData = [{"name":this.state.studentName, "username":this.state.username, "password":this.state.password}]
        this.PDFgen.generateNoClassPDF(studentData);
    }

    handelDownloadSingleData(username, password, name){
        this.PDFgen = new GeneratePDF();
        var studentData = [{"name":name, "username":username, "password":password}]
        this.PDFgen.generateNoClassPDF(studentData);
    }

    renderProfileLink(cell, row){
        return <a href="#">{cell}</a>
    }

    percentage(){
        return <span>0%</span>
    }


    getHeader(title){

        switch(title)
        {
            case "name" : return Translation.get(827 , 'Student Name');
            case "username" : return Translation.get(22 , 'Username');
            case "password" : return Translation.get(23 , 'Password');
            case "vocabLearnt" : return Translation.get(12605 , 'Vocabulary Learnt');
            case "verbLearnt" : return Translation.get(12193 , 'Verbs Learnt');
            case "grammarLearnt" : return Translation.get(12602, 'Grammar Units Learnt');
            case "sentenceLearnt" : return Translation.get(12194 , 'Sentences Learnt');
            case "goldMedals" : return Translation.get(12619 , 'Gold Medals');
            case "silverMedals" : return Translation.get(12620 , 'Silver Medals');
            case "bronzeMedals" : return Translation.get(12621 , 'Bronze Medals');
            case "totalScore" : return Translation.get(12622 , 'World Score');
            case "rank" : return Translation.get(37 , 'World Ranking');
            case "examsCompleted" : return Translation.get(12042 , 'Exam Skills');
            case "last_login" : return Translation.get(13 , 'Login');
            case "rankingScore" : return Translation.get(268 , 'Points');
            case "classes" : return Translation.get(830 , 'Classes');
            case "created" : return Translation.get(830 , 'Created');
        }

        return title
    }

    getPostition(title){

        switch(title)
        {
            case "name" : return 0;
            case "classes" : return 5;
            case "last_login" : return 3;
            case "rankingScore" : return 4;
            case "username" : return 1;
            case "password" : return 2;

        }

        return 0;
    }


    isSort(title){

        switch(title)
        {
            case "username" : return false
            case "password" : return false
            case "name" : return false
            case "classes" : return false
        }

        return true
    }

    getCsvFormatter(uid) {

        if (uid == 'classes') {
            return function(cell , row) {
                var data = "";
                for (var i = 0; i < cell.length; i++) {
                    data += cell[i].name;
                    data += ", ";
                }
                return data;
            }
        }
        return function(cell , row) {

            if(!cell) return 0;
            return cell;
        }
    }

    getFormatter(uid) {

        if (uid == 'classes') {
            return function(cell, row) {
                var endData = [];
                if (cell.length == undefined) {
                    return endData;
                }
                for (var i =0; i < cell.length; i++) {
                    endData.push(<Badge style={{marginLeft:'5px'}}variant="primary" >{cell[i].name}</Badge>);
                }
                return endData;
            } 
        }
        return (cell)=>{

            if(!cell) return 0;
            return cell;
        }
    }

    getCols(){
        if (this.state.students[0] == undefined) {
            return [{
                dataField: 'message',
                text:"",
                csvExport: false,
                formatter: (cell, row)=>{
                    var color = "#FF0000";
                    if (row.is_message_display != "1") {
                        color = "#00FF00";
                    }
                    
                    return <div onClick={function() {
                        this.setState({addMessage:true, messageMessage:"", messageTitle:"", studentUid:row.uid, studentName:row.name});
                    }.bind(this)}><i style={{color:color}} class="fas fa-envelope"></i></div>;
                }
            }];
        }
        var json = this.state.students[0];

        var k = Object.keys(json);
        var c = [];
        var total = [];

        for(var i = 0 ; i < k.length; i++)
        {
            if (i == 1) {
                var number = this.getPostition(k[i]);
                total[number] = {
                dataField: k[i],
                text:  this.getHeader(k[i]),
                sort: this.isSort(k[i]),
                searchable: false,
                filterValue: (cell, row) => cell,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (dataField == "last_login") {
                        var arr = a.split('/');
                        a = new Date(arr[2], arr[1] - 1, arr[0]);
                        var arr = b.split('/');
                        b = new Date(arr[2], arr[1] - 1, arr[0]);
                        if (order === 'asc') {
                            if (a < b) {
                                return -1
                            } else {
                                return 1
                            }
                        }
                        if (a > b) {
                            return -1
                        } else {
                            return 1
                        }  
                    }
                    if (order === 'asc') {
                        if (parseInt(a) < parseInt(b)) {
                            return -1
                        } else {
                            return 1
                        }
                    }
                    if (parseInt(a) > parseInt(b)) {
                        return -1
                    } else {
                        return 1
                    }
                    // desc
                },
                formatter: (cell, row)=>{
                    return <b onClick={function(){window.location.hash = 'students/overview/' + row.uid}} className="hyperlink">{cell}</b>
                }
                };
            } else {
                if(k[i] == 'uid' || k[i] == 'is_message_display' || k[i] == 'rank' || this.state.students[0][k[i]] == null) { 
                    continue;
                }
                var number = this.getPostition(k[i]);
                total[number] = {
                    dataField: k[i],
                    text:  this.getHeader(k[i]),
                    sort: this.isSort(k[i]),
                    searchable: false,
                    sortFunc: (a, b, order, dataField, rowA, rowB) => {
                        if (dataField == "last_login") {
                            var arr = a.split('/');
                            a = new Date(arr[2], arr[1] - 1, arr[0]);
                            var arr = b.split('/');
                            b = new Date(arr[2], arr[1] - 1, arr[0]);
                            if (order === 'asc') {
                                if (a < b) {
                                    return -1
                                } else {
                                    return 1
                                }
                            }
                            if (a > b) {
                                return -1
                            } else {
                                return 1
                            }  
                        }
                        if (order === 'asc') {
                            if (parseInt(a) < parseInt(b)) {
                                return -1
                            } else {
                                return 1
                            }
                        }
                        if (parseInt(a) > parseInt(b)) {
                            return -1
                        } else {
                            return 1
                        }
                        // desc
                    },
                    formatter:this.getFormatter(k[i]),
                    csvFormatter:this.getCsvFormatter(k[i])
                };
            }
        }
        
        total.push({
            dataField: 'message',
            text:"",
            csvExport: false,
            formatter: (cell, row)=>{
                var color = "#FF0000";
                if (row.is_message_display != "1") {
                    color = "#00FF00";
                }
                
                return <div onClick={function() {
                    this.setState({addMessage:true, messageMessage:"", messageTitle:"", studentUid:row.uid, studentName:row.name});
                }.bind(this)}><i style={{color:color}} class="fas fa-envelope"></i></div>;
            }
        })

        total.push({
            dataField: 'printpassword',
            text:"",
            csvExport: false,
            formatter: (cell, row)=>{
                return <div onClick={function() {
                    this.handelDownloadSingleData(row.username, row.password, row.name)
                }.bind(this)}><i class="fas fa-print"></i></div>;
            }
        })

        total.push({
            dataField: 'name',
            text:  '',
            csvExport: false,
            searchable: true,
            hidden:true,
        })


        total.push({
            dataField: 'updatepassword',
            text:"",
            csvExport: false,
            formatter: (cell, row)=>{
                return <div onClick={function() {
                    this.setState({action:"modifyPassword", modifiedPasswordUid:row.uid,
                            studentName:row.name});
                }.bind(this)}><i class="fas fa-key"></i></div>;
            }
        })

        total.push({
            dataField: 'delete',
            text:  '',
            csvExport: false,
            formatter: (cell, row)=>{
                return <div onClick={function() {
                    this.setState({action:"deleteStudent", deletedStudent:row.uid});
                }.bind(this)}><i class="fas fa-trash-alt"></i></div>;
            }
        })

        for (var i = 0; i < 14; i++) {
            if (total[i] != undefined) {
                c.push(total[i]);
            }
        }
        return c
    }

    getPasswordGenerate() {
        return (
            <Modal
                onHide={()=>{this.setState({action:""})}}
                show={this.state.action == 'modifyPassword'}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(12653 , 'Generate new password')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <div >
                                {Translation.get(2444, 'Are you sure you wish to generate a new password?')}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={function(){this.setState({action:""})}.bind(this)}>{Translation.get(12290, "No")}</Button>
                    <Button onClick={function(){
                        
                        UserService.updatePassword(this.state.modifiedPasswordUid).then(function(response){
                            this.setState({
                                action:"showPassword",
                                username:response.username,
                                password:response.password
                            })
                        }.bind(this))
                    }.bind(this)}>{Translation.get(12289, "Yes")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    getPasswordShow() {
        return (
            <Modal
                onHide={()=>{this.setState({action:""})}}
                show={this.state.action == 'showPassword'}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(2423 , 'Student password')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center><h5>{Translation.get(2424 , 'Student\'s Login Details')}</h5></center>
                    <br/>
                    <center><h4>{String(Translation.get(22 , 'Username:') +' '+this.state.username)}</h4></center>
                    <center><h4>{String(Translation.get(23 , 'Password:') +' '+this.state.password)}</h4></center>
                    <br/>
                    <center><h5>{Translation.get(12770 , 'Please keep your details safe and secure')}</h5></center>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{ this.handelDownloadSingle()}}  >{Translation.get(2445,'Download Login')}</Button>
                    <Button onClick={function(){
                        ClassesService.getStudentsAll();
                        this.setState({action:""})}.bind(this)}>{Translation.get(495, "Ok")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    goTo(){
        window.location.hash = 'settings/importer_classes';
    }

    render(){

        if(this.state.loading) return <ProgressBar animated now={45} />
        
        if (!this.state.students) {
            return "";
        }

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.studentName} 
        onSave={()=>{
            AccountService.createMessageStudent(this.state.messageTitle, this.state.messageMessage, this.state.studentUid)
            this.setState({addMessage:false, lastSelected:undefined});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />

        var popup2 = <Popup oneButton={true} buttonTitle={Translation.get(254 , 'Send')} title={Translation.get(2419 , 'Message All Students')} 
            onSave={()=>{
                AccountService.createMessageAccount(this.state.messageTitle, this.state.messageMessage)
                this.setState({addMessage2:false});
            }} 
            onHide={()=>{
                this.setState({addMessage2:false});
            }} 
            show={this.state.addMessage2} 
            body={<div>
                    <Row >
                        <Col sm={{span: 12}}>
                            <FieldGroup value={this.state.messageTitle} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={{span: 12}}>
                            <FieldGroup value={this.state.messageMessage} 
                                        onSelect={(event)=>{
                                            this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                        }} 
                                        onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                        className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                        </Col>
                    </Row>
                    {AccountService.getEmojiData(this)}
                </div>} />
        var buttonMessageAll = <Button style={{marginRight:"10px"}} onClick={function() {
            this.setState({addMessage2:true, messageMessage:"", messageTitle:""})
        }.bind(this)}>{Translation.get(2419 , 'Message All Students')}</Button>;

        if (ProductStore.getUserData().userType != "school" && ProductStore.getUserData().userType != "admin") {
            buttonMessageAll = ""
        }
        buttonMessageAll = [buttonMessageAll,<Button onClick={this.goTo}>{Translation.get(12776 , 'New Class')}</Button>];

        return <Card body>
            {this.getPasswordGenerate()}
            {this.getPasswordShow()}
            {popup}
            {popup2}
            <Comfirmation onSave={function() {
                ClassesService.deleteStudent(this.state.deletedStudent).then(function(){
                        ClassesService.getStudentsAll();
                    }.bind(this))
                }.bind(this)} body={Translation.get(12623 , 'Are you sure you want to delete this student?')} 
                    onHide={()=>{this.setState({action:""})}} show={this.state.action == 'deleteStudent'} />
            <div>
            
            <GeneralTable component={buttonMessageAll} pageSize={40}
                    bordered={ true } keyField='id' data={ this.state.students || [] } columns={ this.getCols() } />
            </div>
        </Card>
    }
}